'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/check/animated.tsx
import { motion } from "motion/react";
import { jsx, jsxs } from "react/jsx-runtime";
var AnimatedCheck = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs(
    motion.svg,
    {
      viewBox: "0 0 121 120",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx(
          motion.path,
          {
            initial: { scale: 0.2, opacity: 0 },
            animate: { scale: 1, opacity: 0.3 },
            transition: { duration: 0.5, delay: 0.2, type: "spring" },
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M60.5 110C88.1142 110 110.5 87.6142 110.5 60C110.5 32.3858 88.1142 10 60.5 10C32.8858 10 10.5 32.3858 10.5 60C10.5 87.6142 32.8858 110 60.5 110Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          motion.path,
          {
            initial: { pathLength: 0, strokeLinecap: "inherit", strokeLinejoin: "inherit" },
            animate: { pathLength: 1, strokeLinecap: "round", strokeLinejoin: "round" },
            transition: { duration: 0.8, delay: 0.4, type: "spring" },
            d: "M35 64.5L52.5 79.5L87.5 42",
            stroke: "currentColor",
            strokeWidth: 10
          }
        )
      ]
    }
  );
};

// src/check/circle.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CheckCircleIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M39.9998 13.3327C25.2722 13.3327 13.3332 25.2718 13.3332 39.9993C13.3332 54.7269 25.2722 66.666 39.9998 66.666C54.7274 66.666 66.6665 54.7269 66.6665 39.9993C66.6665 25.2718 54.7274 13.3327 39.9998 13.3327ZM6.6665 39.9993C6.6665 21.5899 21.5903 6.66602 39.9998 6.66602C58.4093 6.66602 73.3332 21.5899 73.3332 39.9993C73.3332 58.4088 58.4093 73.3327 39.9998 73.3327C21.5903 73.3327 6.6665 58.4088 6.6665 39.9993ZM54.6905 31.197L35.2473 54.9608L23.6191 43.3327L28.3332 38.6186L34.7524 45.0378L49.5308 26.9754L54.6905 31.197Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/check/outlined.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var OutlinedCheckIcon = (props) => /* @__PURE__ */ jsx3(
  "svg",
  __spreadProps(__spreadValues({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00065 1.33325C3.87104 1.33325 1.33398 3.87031 1.33398 6.99992C1.33398 10.1295 3.87104 12.6666 7.00065 12.6666C10.1303 12.6666 12.6673 10.1295 12.6673 6.99992C12.6673 3.87031 10.1303 1.33325 7.00065 1.33325ZM0.333984 6.99992C0.333984 3.31802 3.31875 0.333252 7.00065 0.333252C10.6825 0.333252 13.6673 3.31802 13.6673 6.99992C13.6673 10.6818 10.6825 13.6666 7.00065 13.6666C3.31875 13.6666 0.333984 10.6818 0.333984 6.99992ZM9.31727 4.94627C9.53099 5.12114 9.56249 5.43615 9.38763 5.64987L6.38763 9.31654C6.29818 9.42587 6.16665 9.49226 6.02556 9.4993C5.88447 9.50634 5.74699 9.45336 5.6471 9.35347L4.31376 8.02014C4.1185 7.82488 4.1185 7.50829 4.31376 7.31303C4.50903 7.11777 4.82561 7.11777 5.02087 7.31303L5.96353 8.25569L8.61367 5.01663C8.78854 4.80291 9.10355 4.77141 9.31727 4.94627Z",
        fill: "currentColor"
      }
    )
  })
);

// src/check/static.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var CheckIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 17 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx4("rect", { x: "0.5", width: "16", height: "16", rx: "8", fill: "currentColor" }),
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M11.8472 4.70553C12.0558 4.46006 12.424 4.43021 12.6694 4.63886C12.9149 4.84751 12.9448 5.21565 12.7361 5.46112L7.77779 11.2945C7.56586 11.5438 7.19035 11.57 6.94578 11.3526L4.32078 9.01931C4.07999 8.80528 4.0583 8.43657 4.27233 8.19578C4.48637 7.95499 4.85508 7.9333 5.09587 8.14734L7.27511 10.0844L11.8472 4.70553Z",
            fill: "white"
          }
        )
      ]
    }
  );
};

// src/check/stroke.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var StrokeCheckIcon = (props) => {
  return /* @__PURE__ */ jsx5(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx5(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.4648 2.09861C14.6865 2.26322 14.7328 2.57639 14.5682 2.79811L6.40151 13.7981C6.31982 13.9081 6.19654 13.9798 6.0605 13.9964C5.92446 14.013 5.78758 13.973 5.68186 13.8857L1.5152 10.4482C1.30219 10.2725 1.27197 9.95738 1.4477 9.74437C1.62343 9.53136 1.93857 9.50114 2.15158 9.67688L5.9123 12.7795L13.7653 2.20201C13.9299 1.98029 14.2431 1.934 14.4648 2.09861Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  AnimatedCheck,
  CheckCircleIcon,
  OutlinedCheckIcon,
  CheckIcon,
  StrokeCheckIcon
};
//# sourceMappingURL=chunk-6X4OZQE6.mjs.map